/**
 * PG사 서비스
 */

import apiClient from './api';
import {
  PgProvider,
  PgProviderFilter,
  PgProviderListResponse,
  PgSettlement,
  PgSettlementFilter,
  PgSettlementListResponse,
} from '../types/pg';

export const pgService = {
  /**
   * PG사 목록 조회
   */
  async getProviders(filter: PgProviderFilter = {}): Promise<PgProviderListResponse> {
    const params = new URLSearchParams();
    
    if (filter.status) params.append('status', filter.status);
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: PgProviderListResponse }>(`/admin/pg/providers?${params.toString()}`);
    // return response.data.data;

    return {
      providers: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * PG사 상세 조회
   */
  async getProvider(id: number): Promise<PgProvider> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * PG사 등록
   */
  async createProvider(data: Partial<PgProvider>): Promise<PgProvider> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * PG사 수정
   */
  async updateProvider(id: number, data: Partial<PgProvider>): Promise<PgProvider> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * PG사 삭제
   */
  async deleteProvider(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    throw new Error('Not implemented');
  },

  /**
   * PG사 정산 목록 조회
   */
  async getSettlements(filter: PgSettlementFilter = {}): Promise<PgSettlementListResponse> {
    const params = new URLSearchParams();
    
    if (filter.pg_provider_id) params.append('pg_provider_id', filter.pg_provider_id.toString());
    if (filter.settlement_status) params.append('settlement_status', filter.settlement_status);
    if (filter.start_date) params.append('start_date', filter.start_date);
    if (filter.end_date) params.append('end_date', filter.end_date);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: PgSettlementListResponse }>(`/admin/pg/settlements?${params.toString()}`);
    // return response.data.data;

    return {
      settlements: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },
};

